import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';

import logoBlue from 'assets/images/logo-blue.png';
import { getUpperLevelDomain } from 'utils/functions/authentication';
import { status } from 'constants/general';
import commonStrings from 'modules/common/strings';
import Loader from 'modules/common/components/Loader';

import {
  HeaderWrapper,
  HeaderLogo,
  HeaderLink,
  HeaderUserNameWrapper,
  HeaderUserName,
  HeaderLogoutPopup,
  LogoutBtn,
  HeaderLogout,
  HeaderLogoutIcon,
  HeaderUserNameLoaderWrapper,
  HeaderLogoutConfirmation,
} from './Header.style';
// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const Header = ({ loginInfo }) => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const userNameWrapperRef = useRef(null);
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [isLogoutPopupOpen, setIsLogoutPopupOpen] = useState(false);
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    const handleClickOutside = event => {
      if (userNameWrapperRef.current && userNameWrapperRef.current.contains(event.target) === false)
        setIsLogoutPopupOpen(false);
    };
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [userNameWrapperRef]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleUsernameClick = () => {
    setIsLogoutPopupOpen(prevState => !prevState);
  };

  const handleLogoutClick = () => {
    setIsLogoutPopupOpen(false);
    const domain = getUpperLevelDomain();
    Cookies.remove('veezAuth', { domain });
    Cookies.remove('opsReturnURL');
    document.location.href = '/login';
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <HeaderWrapper>
      <HeaderLink to="/members/">
        <HeaderLogo src={logoBlue} />
      </HeaderLink>
      {((loginInfo.status === status.SHOULD_CALL_API || loginInfo.status === status.FETCHING) && (
        <HeaderUserNameLoaderWrapper>
          <Loader width={16} height={16} thickness={4} />
        </HeaderUserNameLoaderWrapper>
      )) || (
        <HeaderUserNameWrapper ref={userNameWrapperRef}>
          <HeaderUserName onClick={() => handleUsernameClick()}>
            {loginInfo.details.data.username}
          </HeaderUserName>
          {isLogoutPopupOpen && (
            <HeaderLogoutPopup>
              <HeaderLogoutConfirmation>
                {commonStrings.header.logoutConfirm}
              </HeaderLogoutConfirmation>
              <LogoutBtn onClick={() => handleLogoutClick()}>
                <HeaderLogoutIcon />
                <HeaderLogout>{commonStrings.header.logoutText}</HeaderLogout>
              </LogoutBtn>
            </HeaderLogoutPopup>
          )}
        </HeaderUserNameWrapper>
      )}
    </HeaderWrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

Header.propTypes = {
  loginInfo: PropTypes.shape({
    status: PropTypes.string,
    details: PropTypes.shape({
      data: PropTypes.shape({
        username: PropTypes.string,
      }),
    }),
  }).isRequired,
};

Header.defaultProps = {};

export default Header;
